import Registration from '../../../components/Auth/Registration/Registration';

const RegistrationPage = () => {
  return <Registration />;
};

export default RegistrationPage;
